// Dependencies
import { h, Component } from 'preact';
// Helpers
import dayjs from 'lib/helpers/dayjs';

// Styles
import style from './style.less'

// Functional Component
export default (props)=>{
    let timeSlotSytle = style.timeSlot
    
    if(props.selected){
        timeSlotSytle += ` ${style.selected}`
    }

    if (props.class){
        timeSlotSytle += ` ${props.class}`
    }

    return (
        <div key={props.id} class={timeSlotSytle} onClick={props.onSelect} id={props.id}>
            {dayjs(props.startsAt).format("hh:mm A")}
        </div>
    )
}


// WEBPACK FOOTER //
// ./components/elements/TimeSlot/index.js